<template>
    <div class="col-md-12 mb-4" v-if="workingHours.length > 0">
        <div class="container-box">
            <div class="container-box-title">{{ translate.account.workingHours }}</div>
            <div class="container-box-content" id="profile-page-working-hours">
                <table>
                    <tbody>
                    <tr v-for="(value, index) in formattedWorkingHours" :key="index">
                        <td>
                            <span class="grey-text text-uppercase">{{ translate.home.daysOfWeek[index] }}</span>
                        </td>
                        <td>
                            <span v-if="value.text === translate.home.notAvailable" class="not-available">
                                {{ value.text }}
                            </span>
                            <span v-else v-for="entry in value.text">
                                {{ entry }}
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    computed: {
        ...mapState(['translate']),
        formattedWorkingHours(){
            const user_working_hours = _.sortBy(this.workingHours, 'day');
            const result_working_hours = [];

            for (let i = 0; i < 7; i++) {
                const day = _.first(_.filter(user_working_hours, value => value.day === i));
                if (!day) {
                    result_working_hours.push({day: i, text: _.get(this, 'translate.home.notAvailable', '')});
                    continue;
                }

                const result = [];
                if (_.get(day, 'morning', false)) {
                    result.push(_.get(this, 'translate.home.morning', ''));
                }
                if (_.get(day, 'afternoon', false)) {
                    result.push(_.get(this, 'translate.home.afternoon', ''));
                }
                if (_.get(day, 'evening', false)) {
                    result.push(_.get(this, 'translate.home.evening', ''));
                }
                result_working_hours.push({day: i, text: result});
            }
            return result_working_hours;
        }
    },
    props: {
        workingHours: {default:[]},
    },
}
</script>
